// extracted by mini-css-extract-plugin
export default {"required":"UploadFileInput_required__u5qr1"};